"use strict";

import * as React from 'react';

/**
 * Context which marks the navigation tree as independent.
 */
export const NavigationIndependentTreeContext = /*#__PURE__*/React.createContext(false);
//# sourceMappingURL=NavigationIndependentTreeContext.js.map